import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../utils/constants';
import Header from '../layout/Header';
import './PendingVerification.css';

const PendingVerification = () => {
  const queryClient = useQueryClient();

  const handleRefresh = () => {
    // Refetch user data to check if verification status has changed
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.USERS.ME });
  };

  return (
    <div className="pending-verification">
      <Header />
      
      <div className="pending-verification__content">
        <div className="pending-verification__container">
          <div className="pending-verification__icon">
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          
          <h1 className="pending-verification__title">
            Account Pending Verification
          </h1>
          
          <p className="pending-verification__message">
            Your account is currently pending admin verification. 
            Once an administrator reviews and approves your account, 
            you will be able to access all features.
          </p>
          
          <p className="pending-verification__submessage">
            Please check back later or contact support if you have any questions.
          </p>
          
          <button 
            className="pending-verification__refresh-button"
            onClick={handleRefresh}
          >
            Check Verification Status
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingVerification;

